let menuToggle = document.querySelector('.menu-toggle');
let menuClose = document.querySelector('.menu-close');
let menu = document.querySelector('.menu');
let main = document.querySelector('body');

menuToggle.addEventListener('click', () => {
    menu.classList.toggle('menu-open');
    main.classList.toggle('scrollock')

})
menuClose.addEventListener('click', () => {
    menu.classList.toggle('menu-open');
    main.classList.toggle('scrollock')
})